import { MutableRefObject, useContext, useEffect } from 'react';
import { useTypedFastStorage } from '../../hooks/useFastStorage';
import SecondaryButton from "../../ui/SecondaryButton";
import { parseInt } from "lodash";
import { JobNames } from "../../framework.core/JobNames";
import ApplicationContext from "../../ApplicationContext";
import { DocumentType } from "../../framework.core/DocumentType";
import useGlobalOkDialog from '../../hooks/useGlobalOkDialog';
import useReportViewer from '../../hooks/useReportViewer';
import BankDropDown from '../../uiControls/BankDropDown';
import CheckBox from '../../ui/CheckBox';
import InlineInputControlRow from '../../ui/layout/InlineInputControlRow';
import Fieldset from '../common/Fieldset';
import { CheckArgs, ChkMessengerArgs } from '../../fms.report/args';
import useGlobalYesNoDialog from '../../hooks/useGlobalYesNoDialog';
import TextBox from '../../ui/TextBox';


interface ICheckPrint {
  printCheck: boolean,    //g_Print_Check
  printMessanger: boolean, // public bool g_Print_Messanger; //리턴값
  checkRange: boolean,    // public bool m_bCheckRange;     //받는값
  slip: boolean,        // public bool m_bSlip;
  checkFrom: string,    // public string m_sCheckFrom;    //리턴값
  checkTo: string,     // public string m_sCheckTo;      //리턴값
  bankId: number,     // public int m_BankId;        //리턴값
  batchCheck: boolean, //only cloud,
  draftOrVoid?: boolean | null,
}

interface PrintData {
  id: number,
  bankId: number,
  checkNo?: string,
  checkTo?: string,
  checkFrom?: string,
}

interface CheckPrintStorageKeys {
  modelStorage: string,
};

interface CheckPrintViewParams {
  onPopupClose?: () => void,
  checkRange: boolean,
  selectedElement: any,
  documentType: DocumentType,
  batchCheck: boolean,
  draftOrVoid?: boolean | null,
};

function getBatchPrintStorageKeys(): CheckPrintStorageKeys {
  return { modelStorage: 'common-more-arrival-notice' }
}

interface CheckPrintDetailsViewParams {
  checkPrint: ICheckPrint,
  checkPrintRef: MutableRefObject<ICheckPrint | null>,
  setCheckPrint: (x: Partial<ICheckPrint>) => void,
  onPopupClose?: () => void,
  documentType: DocumentType,
  selectedElement: PrintData,
  draftOrVoid?: boolean | null,
};

function CheckPrintImpl(params: CheckPrintViewParams) {

  const { modelStorage } = getBatchPrintStorageKeys();
  const { selectedElement, checkRange, documentType, batchCheck } = params;

  const [inStorage, setInStorage, removeBatchPrintFromStorage, batchPrintRef] = useTypedFastStorage<ICheckPrint>(modelStorage, null);

  useEffect(() => {
    initialize();
    return () => removeBatchPrintFromStorage()
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedElement?.id]
  );

  async function loadExisting(): Promise<ICheckPrint> {
    return {
      printCheck: false,
      printMessanger: false,
      checkRange: checkRange,
      slip: false,
      checkFrom: batchCheck ? selectedElement.checkFrom : '',
      checkTo: batchCheck ? selectedElement.checkTo : '',
      bankId: batchCheck? selectedElement.bankId : 0,
      batchCheck: batchCheck,
    }
  }

  async function initialize() {
    const data = await loadExisting();
    setInStorage({ ...data })
  }

  if (!inStorage) {
    return null;
  }

  return (
    <CheckPrintInitializedImpl
      checkPrint={inStorage}
      checkPrintRef={batchPrintRef}
      setCheckPrint={setInStorage}
      onPopupClose={params.onPopupClose}
      selectedElement={selectedElement}
      documentType={documentType}
      draftOrVoid={params.draftOrVoid}
    />
  );
}


function CheckPrintInitializedImpl({
  checkPrint,
  setCheckPrint,
  onPopupClose,
  selectedElement,
  documentType,
  draftOrVoid,
}: CheckPrintDetailsViewParams) {

  const appContext = useContext(ApplicationContext)
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const { viewReport } = useReportViewer();

  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  function onChange(change: Partial<ICheckPrint>) {
    setCheckPrint(change);
  }


  async function checkPrintOptions(isPreview: boolean = true) {
    let errorMsg = '';
    let errflag = false;

    if (checkPrint.checkRange) {
      const fromno = parseInt(checkPrint.checkFrom);
      const tono = parseInt(checkPrint.checkTo);

      if (fromno > tono || fromno === 0) {
        errorMsg = 'Invalid Check #!!!';
        errflag = true;
      }

      if (checkPrint.bankId < 0) {
        errorMsg = 'Invalid Bank!!!';
        errflag = true;
      }

    }
    if (errflag) {
      await showGlobalOkDialog(<p>{errorMsg}</p>, false);
      return false;
    }

    return true;
  }

  async function print() {

    if (!await checkPrintOptions()) return;

    if (!selectedElement) {
      return;
    }

    if (checkPrint.checkRange) {
      const doConfirm = await showGlobalYesNoDialog(
        <div>
          <p>
            Check Number {checkPrint.checkFrom} - {checkPrint.checkTo} 
            <br />
            Are you sure?
          </p>
        </div>
      ,false, 0, true);

      if (!doConfirm) {
        return;
      }
    }


    const formName = await appContext.api.getCheckFormName(selectedElement.id)??'';
    
    // do print
    let args;
    if(!checkPrint.batchCheck && !checkPrint.checkRange){
      const title = `Check [${selectedElement?.checkNo}]`;
      args = new CheckArgs({  //Print Check
        docType: documentType,
        // formName: appContext.suntekSettings?.company?.checkFormName||'',
        formName,
        formCaption: title,
        subject: title,
        tbName: 'T_DEPOHD',
        tbId:(selectedElement?.id.toString() ?? ''),
      });
      viewReport(args, "", true);
    } else {
        const title = `Check [${checkPrint.checkFrom}] - [${checkPrint.checkTo}]`;
        args = new CheckArgs({
          docType: documentType,
          formCaption: title,
          subject: title,
          // formName: appContext.suntekSettings?.company?.checkFormName||'',
          formName,
          fromNo: checkPrint.checkFrom.toString(),
          toNo: checkPrint.checkTo.toString(),
          bank: checkPrint.bankId,
          tbName: 'T_DEPOHD',
        });
        viewReport(args, "", true);
        if(onPopupClose){
          onPopupClose();
        }
    } 

    if (checkPrint.printMessanger === true) {
      const title = `Check [${selectedElement?.checkNo}]`;
      setTimeout(() => {
        args = new ChkMessengerArgs({
          docType: DocumentType.ChkMessenger,
          formCaption: title,
          subject: title,
          tbName: 'T_DEPOHD',
          tbId: selectedElement?.id.toString() ?? '',
        });
        viewReport(args, "", true);

      }, 500);
    }

    
    // update memo panel.

    
  }


  return (
    <div className='report-popup'>
      <div>Is your Check printer ready?  Click YES to print.
        {draftOrVoid &&  (
          <>
            <br /> <br /> <br /> 
            <span style={{ float: 'right' }}>(Draft/Void Payment cant't print checks.)</span>
          </>
        )}
      </div>

      {!checkPrint.checkRange &&
        <div style={{ marginTop: '15px', marginBottom: '20px' }}>
          <CheckBox label='Print Messenger Slip' value={checkPrint.printMessanger} onChange={printMessanger => onChange({ printMessanger })} />
        </div>
      }

      {checkPrint.checkRange &&
        <div>
          <Fieldset label={''}>
            <div style={{ marginLeft: '30px', display: 'flex', marginTop: '10px', marginBottom: '10px' }}>
              <div style={{ width: '90px' }}>Check Number</div>
              <div style={{ width: '80px' }}>
              <TextBox value={checkPrint.checkFrom} onChange={e => setCheckPrint({ checkFrom: e.target.value })} alignRight />
              </div>
              <div style={{ width: '50px', textAlign: 'center' }}>
                ~
              </div>
              <div style={{ width: '80px' }}>
              <TextBox value={checkPrint.checkTo} onChange={e => setCheckPrint({ checkTo: e.target.value })} alignRight />
              </div>
            </div>
          </Fieldset>
        </div>
      }

      {checkPrint.checkRange &&
        <div style={{ marginTop: '15px', marginBottom: '10px' }}>
          <div style={{ width: '300px' }}>
            <InlineInputControlRow label='Bank' mode='w80' smallMargin>
              <BankDropDown
                value={checkPrint.bankId ?? 0}
                onChange={async bank => {
                  setCheckPrint({
                    bankId: bank?.id || 0
                  });
                }}
                disabled={selectedElement?.bankId > 0}
                autoSetDefault
              />

            </InlineInputControlRow>
          </div>
        </div>
      }



      <div className='report-footer'>
        <SecondaryButton
          size="regular"
          style={{ width: '90px' }}
          onClick={() => print()}>
          Yes
        </SecondaryButton>
        <SecondaryButton
          size="regular"
          style={{ width: '90px' }}
          onClick={onPopupClose}>
          No
        </SecondaryButton>
      </div>
    </div>
  );
}

const CheckPrintDetails = ({
  onPopupClose,
  checkRange,
  selectedElement,
  // jobName,
  documentType,
  batchCheck,
  draftOrVoid,
}: {
  onPopupClose?: () => void, selectedElement: PrintData, documentType: DocumentType, //jobName: JobName, 
  checkRange: boolean, batchCheck: boolean, draftOrVoid?: boolean | null
}) => {
  if (!selectedElement) return null;

  /**
   * Implementation note:
   *   key is important in this case in order to force full List view rerender for different parameters.
   */

  return (
    <CheckPrintImpl
      checkRange={checkRange}
      documentType={documentType}
      selectedElement={selectedElement}
      onPopupClose={onPopupClose}
      key={`checkPrint-details`}
      batchCheck={batchCheck}
      draftOrVoid={draftOrVoid}
    />
  );
};
export default CheckPrintDetails;
